import { environmentConfig } from "../../environment";

export const SUPPORT_ARTICLES_URL = `${environmentConfig.REACT_APP_BASE_API_URL}/support-articles`;
